anim8.defaults.duration = 1500;

anim8.easingType.reverse = function(easing)
{
  return function(d) {
    return easing( 1.0 - d );
  };
};

anim8.easingType.backwards = function(easing)
{
  return function(d) {
    return 1.0 - easing( d );
  };
};

anim8.clamp = function(d, min, max)
{
  return (d < min ? min : (d > max ? max : d));
};

anim8.wrapAngle = function(a)
{
  return a + 360 * Math.floor( ( 180 - a ) / 360 );
};

(function(calc) 
{
  calc.ZERO = calc.create();

  calc.lengthSq = function(a) 
  {
    return calc.distanceSq( a, calc.ZERO );
  };

  calc.length = function(a) 
  {
    return calc.distance( a, calc.ZERO );
  };

  calc.setLength = function(a, length) 
  {
    var currentLength = calc.length( a );
    return currentLength === 0.0 ? a : calc.scale( a, length / currentLength );
  };

  calc.clamp = function(a, min, max) 
  {
    var currentLengthSq = calc.lengthSq( a );
    if ( currentLengthSq !== 0.0 ) {
      if ( currentLengthSq < min * min ) {
        return calc.scale( a, min / Math.sqrt( currentLengthSq ) );
      }
      if ( currentLengthSq > max * max ) {
        return calc.scale( a, max / Math.sqrt( currentLengthSq ) );
      }
    }
    return a;
  };

  calc.dot = function(a, b)
  {
    return a.x * b.x + a.y * b.y;
  };

})( anim8.calculator[ '2d' ] );

anim8.scaleValue = function(value)
{
  return function() {
    return window.$container ? window.$container.getScale() * value : value;
  };
};

anim8.save('borderGrow', {
	keyframe: {
		from: { 
			borderWidth: anim8.scaleValue( 5 )
		},
		to: { 
			borderWidth: anim8.scaleValue( 35 )
		}
	},
	units: {
		borderWidth: 'px'
	}
});

anim8.save('borderShrink', {
	keyframe: {
		from: { 
			borderWidth: anim8.scaleValue( 35 )
		},
		to: { 
			borderWidth: anim8.scaleValue( 5 )
		}
	},
	units: {
		borderWidth: 'px'
	}
});

anim8.save('slideInLeftBig', {
	keyframe: {
		from: {
			translate: {x:-200, y:0}
		},
		to: {
			translate: 0
		}
	},
	units: {
		translate: '%'
	}
});

anim8.save('rotateLeft', {
  keyframe: {
    from: {
      rotate: 0,
      easing: 'linear'
    },
    to: {
      rotate: 360
    }
  }
});

anim8.save('rotateRight', {
  keyframe: {
    from: {
      rotate: 0,
      easing: 'linear'
    },
    to: {
      rotate: -360
    }
  }
});

anim8.save('nextIn', {
  keyframe: {
    from: {
      translate: {x: -40 / 125 * 100, y: -40 / 101 * 100},
      opacity: 0
    },
    to: {
      translate: 0,
      opacity: 1
    }
  },
  units: {
    translate: '%'
  }
});

anim8.save('nextOut', {
  keyframe: {
    from: {
      translate: 0
    },
    to: {
      translate: 125
    }
  },
  units: {
    translate: '%'
  }
});

anim8.save('invisible', {
  initial: {
    opacity: 0
  }
});

anim8.save('growRight', {
  initial: {
    origin: 'left center'
  },
  keyframe: {
    from: {
      scaleX: 0
    },
    to: {
      scaleX: 1
    }
  }
});

anim8.save('growLeft', {
  initial: {
    origin: 'right center'
  },
  keyframe: {
    from: {
      scaleX: 0
    },
    to: {
      scaleX: 1
    }
  }
});

anim8.save('growDown', {
  initial: {
    origin: 'center top'
  },
  keyframe: {
    from: {
      scaleY: 0
    },
    to: {
      scaleY: 1
    }
  }
});

anim8.save('growUp', {
  initial: {
    origin: 'center bottom'
  },
  keyframe: {
    from: {
      scaleY: 0
    },
    to: {
      scaleY: 1
    }
  }
});

if ( IE.version() === false )
{
  var isOlder = (
    (Safari.version() !== false && Safari.version() < 7) ||
    (Chrome.version() !== false && Chrome.version() < 31)
  );

  anim8.save('highlight', {
    keyframe: {
      from: {
        brightness: isOlder ? 0 : 100,
        easing: 'ease-pong'
      },
      to: {
        brightness: isOlder ? 20 : 200
      }
    }
  });

  anim8.save('highlight-half', {
    keyframe: {
      from: {
        brightness: isOlder ? 0 : 100,
        easing: 'ease-pong'
      },
      to: {
        brightness: isOlder ? 10 : 150
      }
    }
  });
}
else
{
  // IE doesn't support CSS filters, use opacity instead
  anim8.save('highlight', {
    keyframe: {
      from: {
        opacity: 1,
        easing: 'ease-pong'
      },
      to: {
        opacity: 0.3
      }
    }
  });

  anim8.save('highlight-half', {
    keyframe: {
      from: {
        opacity: 1,
        easing: 'ease-pong'
      },
      to: {
        opacity: 0.3
      }
    }
  });
}

// Add a random function to jquery
$.fn.random = function()
{
  return $( this[ Math.floor( Math.random() * this.length ) ] );
};

/**
 * Wraps every character with a span and the class sequenced and returns a jquery
 * element containing all wrapped characters.
 * 
 * @return {jQuery}
 */
$.fn.sequence = function(tagName, attributes, returnSelector)
{
  var tagName = anim8.coalesce( tagName, 'div' );
  var attributes = anim8.coalesce( attributes, 'class="sequenced"' );
  var returnSelector = anim8.coalesce( returnSelector, '.sequenced' );

  this.each(function()
  {
    $(this).html( $(this).wrapCharacters( tagName , attributes ) );
  });

  return this.find( returnSelector );
};

/**
 * Wraps every character in ever element in the jQuery object with a tag.
 * If an element already only has one character it remains untouched.
 * 
 * @param  {string} tagName
 * @param  {string} attributes
 * @return {string} attributes
 */
$.fn.wrapCharacters = function(tagName, attributes)
{
  var tagBegin = '<' + tagName + (typeof attributes === 'string' ? ' ' + attributes : '') + '>';
  var tagEnd = '</' + tagName + '>';
  var html = '';

  $(this).contents().each(function()
  {
    // Is this a text node?
    if (this.nodeType === 3)
    {
      // Break up node wrapping each character
      var text = this.data;

      if (text.length > 1)
      {
        // Collapse whitespaces
        var previousSpace = false;
        for (var i = 0; i < text.length; i++)
        {
          var space = text[i] <= ' ';
          if (!space || !previousSpace)
          {
            html += tagBegin + text[i] + tagEnd;
          }
          previousSpace = space;
        }
      }
      else
      {
        html += text;
      }
    }
    else
    {
      // Not a text node!
      var outer = this.outerHTML;
      // If there are children, we need to recursively break them down
      if (this.firstChild)
      {
        // Grab the element tag and attributes manually.
        var start = 0;
        var quotes = false;
        while (start < outer.length)
        {
          var c = outer[start++];
          if (c === '"' || c === "'")
          {
            quotes = !quotes;
          }
          else if (c === '\\')
          {
            start++;
          }
          else if (c === '>' && !quotes)
          {
            break;
          }
        }
        html += outer.substring(0, start) + $(this).wrapCharacters(tagName) + '</' + this.tagName.toLowerCase() + '>';
      }
      // No child nodes, just append outer HTML.
      else
      {
        html += outer;
      }
    }
  });

  return html;
};
